import { FunctionComponent, ReactNode } from 'react';
import { twMerge } from 'src/utils/twMerge';

type Variant = 'tour' | 'speech';

type Props = {
  children: ReactNode;
  isTailOnTop?: boolean;
  variant?: Variant;
  className?: string;
};

const VARIANT_CLASSES: Record<
  Variant,
  { bubble: string; text: string; tail: string }
> = {
  tour: {
    bubble: 'rounded-xl bg-warning-lighter p-3',
    text: 'text-xs',
    tail: 'fill-warning-lighter',
  },
  speech: {
    bubble: 'rounded-2xl bg-white px-4 py-3 shadow-3xl',
    text: 'text-lg leading-[1.3] text-center text-balance',
    tail: 'fill-white',
  },
};

const TAIL_CLASSES = {
  top: 'bottom-full translate-y-1',
  bottom: 'top-full -translate-y-1 rotate-180',
};

const TourTooltip: FunctionComponent<Props> = ({
  children,
  isTailOnTop = false,
  variant = 'tour',
  className,
}) => (
  <div
    role="status"
    className={twMerge('relative', VARIANT_CLASSES[variant].bubble, className)}
  >
    <span
      className={twMerge(
        'block text-center font-bold text-structural-darkest',
        VARIANT_CLASSES[variant].text,
      )}
    >
      {children}
    </span>
    <svg
      aria-hidden
      viewBox="0 0 20 14"
      className={twMerge(
        'absolute left-1/2 h-3.5 w-5 -translate-x-1/2',
        VARIANT_CLASSES[variant].tail,
        TAIL_CLASSES[isTailOnTop ? 'top' : 'bottom'],
      )}
    >
      <path d="M0 10 L10 0 L20 10 V14 H0 Z" />
    </svg>
  </div>
);

export default TourTooltip;
